// @file Tldraw Background component
import { createBridgeToReactState } from '@@/bits/vue_react_bridge'
import { useWhiteboardCardTemplatesStore } from '@@/pinia/whiteboard_card_templates'
import WhiteboardCardTemplatePreview from '@@/reactcomponents/WhiteboardCardTemplatePreview'
import WhiteboardFrameBackground from '@@/reactcomponents/WhiteboardFrameBackground'
import { computed } from 'vue'

const whiteboardCardTemplatesStore = useWhiteboardCardTemplatesStore()

const useIsShowingCardTemplatePreview = createBridgeToReactState(
  computed<boolean>(() => whiteboardCardTemplatesStore.isShowingCardTemplatePreview),
)

const Background = (): React.JSX.Element => {
  const [isShowingCardTemplatePreview] = useIsShowingCardTemplatePreview()
  return (
    <>
      <WhiteboardFrameBackground
        style={{
          width: '100%',
          height: '100%',
          display: isShowingCardTemplatePreview ? 'none' : undefined,
        }}
      />
      {isShowingCardTemplatePreview && <WhiteboardCardTemplatePreview />}
    </>
  )
}

export default Background
